import { ITPP, IApplication } from '../../../API/ApiManagementTypes';
import { Action } from '../../actions/index';
import { FLUSH_STATE } from '../ApiManagementSandboxReducers/ApiManagementSandboxReducers';
export interface IGoLiveState {
    tpp?: ITPP
    application?: IApplication
    hideButtons?: boolean
}

const initialGoLiveState: IGoLiveState = {
    tpp: null,
    application: null,
    hideButtons: false
}

export const SET_PROD_APP = 'SET_PROD_APP';
export const SET_PROD_TPP = 'SET_PROD_TPP';
export const REMOVE_PROD_TPP = 'REMOVE_PROD_TPP';
const HIDE_GO_LIVE_BUTTONS = 'HIDE_GO_LIVE_BUTTONS'
const SHOW_GO_LIVE_BUTTONS = 'SHOW_GO_LIVE_BUTTONS'
export const hideButtonAction = { type: HIDE_GO_LIVE_BUTTONS }
export const showButtonAction = { type: SHOW_GO_LIVE_BUTTONS }

export function goLiveReducer(state = initialGoLiveState, action: Action<ITPP | IApplication>): IGoLiveState {
    switch (action.type) {
        case SET_PROD_APP:
            return { ...state, application: action.payload as IApplication }
        case SET_PROD_TPP:
            return { ...state, tpp: action.payload as ITPP }
        case REMOVE_PROD_TPP:
            return { ...state, tpp: null }
        case FLUSH_STATE: return initialGoLiveState
        case HIDE_GO_LIVE_BUTTONS:
            return { ...state, hideButtons: true }
        case SHOW_GO_LIVE_BUTTONS:
            return { ...state, hideButtons: false }
        default:
            return { ...state }
    }
}